import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { request, withRetry } from 'src/commons/utils/async-request';

const getSelectedApplicationEndpoint = `/ccx/ajax/selectedApplication`;

interface GetSelectedApplicationResponse {
  selectedApplicationId: string;
}

const requestWithRetry = withRetry<
  AxiosRequestConfig,
  Promise<AxiosResponse<GetSelectedApplicationResponse>>
>(async (config) => {
  return request<GetSelectedApplicationResponse>(config);
});

export default async (): Promise<string> => {
  try {
    const response = await requestWithRetry({
      url: getSelectedApplicationEndpoint,
    });
    return response.data.selectedApplicationId;
  } catch (e) {
    return '';
  }
};
